function stripDevPort(origin = window.location.origin) {
    return origin.replace(/:(3000|5173)$/, "");
}

// ¿vive bajo /Ejecuciones?
function appBase() {
    const p = window.location.pathname.toLowerCase();
    if (p.startsWith("/ejecuciones")) return "/Ejecuciones";
    return "/Ejecuciones";
}

// En dev (puerto 3000/5173) => ""  | en prod => "https://host"
function baseOrigin() {
    const origin = window.location.origin;
    if (/:3000$|:5173$/.test(origin)) return "";   // dev → usar proxy
    return stripDevPort(origin);                   // prod
}

/** /Ejecuciones/apis/<rel> */
export function apiPath(relative = "") {
    const clean = String(relative || "").replace(/^\/+/, "");
    // En dev queda "/apis/loquesea" → lo agarra el proxy
    // En prod queda "https://host/Ejecuciones/apis/loquesea"
    const base = baseOrigin();
    if (base === "") return `/apis/${clean}`;
    return `${base}${appBase()}/apis/${clean}`;
}

export const apisPath = apiPath;

export function ejecucionesPath(relative = "") {
    const clean = String(relative || "").replace(/^\/+/, "");
    const base = baseOrigin();
    if (base === "") return `/${clean}`; // dev: relativo
    return `${base}${appBase()}/${clean}`;
}

export function appPath(relative = "") {
    const clean = String(relative || "").replace(/^\/+/, "");
    const base = baseOrigin();
    if (base === "") return `/${clean}`;
    return `${base}${appBase()}/${clean}`;
}

/**
 * nodeApiPath - Apunta al backend Node.
 *
 * - Si el frontend corre en el dev server (puerto 3000/5173): URL absoluta a
 *   `https://<host>:3001` para hablar directo con Node desde la red interna.
 * - Si corre detrás de un reverse proxy (Caddy/IIS) en :443 sin puerto explícito:
 *   ruta relativa `/api/...` para que el proxy la enrute a Node:3001.
 *   Esto evita exponer 3001 hacia afuera y permite usar el cert TLS del proxy
 *   (Let's Encrypt) en lugar del self-signed del backend.
 */
export function nodeApiPath(relative = "") {
    const clean = String(relative || "").replace(/^\/+/, "");
    const origin = window.location.origin;

    // Dev local sin proxy: hablamos directo a Node 3001 (cert self-signed).
    if (/:3000$|:5173$/.test(origin)) {
        const hostname = window.location.hostname;
        return `https://${hostname}:3001/api/${clean}`;
    }

    // Prod / staging detrás de reverse proxy: ruta relativa.
    return `/api/${clean}`;
}
